import logo from "./logo.svg";
import "./App.css";
import LoginPage from "./Pages/Login";
import SliderManagement from "./Pages/HomePage/SliderManagement";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AboutAlumni from "./Pages/AlumniSection/AboutAlumni";
import WelcomeSection from "./Pages/HomePage/WelcomeSection";
import LeadershipMessageDep from "./Pages/Academics_International/LeadershipMessages";

import About_SAB from "./Pages/About_Us/About_SAB_Page/About_SAB";
import LeadershipMessages from "./Pages/About_Us/About_SAB_Page/Leadership_Messages";

import PartnersAccrMng from "./Pages/HomePage/PartnersAccrMng";
import GalleryManagement from "./Pages/HomePage/GalleryManagement";

import Council from "./Pages/About_Us/Council/Council";
import Management from "./Pages/About_Us/Board_of_Management/Management";
import Studies from "./Pages/About_Us/Board_of_Studies/Studies";

import SABLayout from "./Pages/SABLayout";

import DepartmentManagement from "./Pages/Academics_International/DepartmentManagement";

import AboutAlumniupdateGoals from "./Pages/AlumniSection/AboutAlumni-updateGoals";
import AlumniLatestNews from "./Pages/AlumniSection/AlumniLatestNews";
import AlumniRegistration from "./Pages/AlumniSection/AlumniRegistration";

import AcademicStaff from "./Pages/Academics_International/AcademicStaff";
import AllStaff from "./Pages/Academics_International/AllStaff";

import SABSRC from "./Pages/Research/SABSRC";
import PrivateRoute from "./Components/PrivateRoute";
import AddDegree from "./Pages/Academics_International/AddDegree";
import AllDegree from "./Pages/Academics_International/AllDegree";
import Applications from "./Pages/Academics_International/Applications";


import AddPublication from "./Pages/add new publication/add_new_publication";
import AddClubSociety from "./Pages/clubs and societies/clubs_n_societies";
import ClubSocietyList from "./Pages/clubs and societies/table_list";


// import AddClubSociety from './Pages/clubs and societies/clubs_n_societies';
// import ClubSocietyList from './Pages/clubs and societies/table_list';

import AddProgram from './Pages/Academics_International/AddProgram';
import AllPrograms from './Pages/Academics_International/AllPrograms';
import AddLoan from './Pages/Academics_International/AddLoan';
import AllLoans from './Pages/Academics_International/AllLoans';
import AddScholarship from './Pages/Academics_International/AddScholarship';
import AllScholarships from './Pages/Academics_International/AllScholarships';
import Gallery from './Pages/Gallery_News/Gallery';
import ResearchPublications from './Pages/Research/ResearchPublications';


// import AddProgram from "./Pages/Academics_International/AddProgram";
// import AllPrograms from "./Pages/Academics_International/AllPrograms";
// import AddLoan from "./Pages/Academics_International/AddLoan";
// import AllLoans from "./Pages/Academics_International/AllLoans";

import ITServices from "./Pages/IT_Services/IT_Services";
import StudentPortal from "./Pages/IT_Services/Student_Portal"
import Office from "./Pages/IT_Services/office"
import OnlinePayment from "./Pages/IT_Services/Online_Payment"
import PasswordManagment from "./Pages/IT_Services/Password_Managment";
import HelpDesk from "./Pages/IT_Services/Help_Desk";
import IMS from "./Pages/IT_Services/Ims";

import ContactInformation from "./Pages/Contact_Us/contact_information"
import Inquiry from "./Pages/Contact_Us/inquiry";


import AddNews from "./Pages/Gallery_News/addNews";
import GetNews from "./Pages/Gallery_News/getNews";
import GetCQADesc from "./Pages/Gallery_News/CQADescription"
import AddCQA from "./Pages/Gallery_News/addCQA";
import GetCQA from "./Pages/Gallery_News/getCQA"
import CQAStaff from "./Pages/Gallery_News/CQAStaff";

import NewsGalleryManagement from "./Pages/Gallery_News/GalleryManagement";
// import VideoGallery from "./Pages/Gallery_News/videoGallery";

import StudentLife from "./Pages/Research/StudentLife";
import CSRProjects from "./Pages/Research/CSRProjects";
import StudentEvents from "./Pages/Research/StudentEvents";
import Sports from "./Pages/Research/Sports";
import CareerGuidanceInternships from "./Pages/Research/CareerGuidanceInternships";
import Career from "./Pages/Career/Career";


import ResetPassword from "./Pages/ResetPassword";
import StudentEvents_Edit from "./Pages/Research/StudentEvents_Edit";
import StudentEventsEdit from "./Pages/Research/StudentEvents_Edit";
import OurHistory from "./Pages/About_Us/About_SAB_Page/OurHistory";
import Intakes from "./Pages/AlumniSection/Intakes";
import VideoGallery from "./Pages/Gallery_News/VideoGallery";
import Student_Counsellor from "./Pages/IT_Services/Student_Counsellor";
import AlumniDirectory from "./Pages/AlumniSection/AlumniDirectory";
import PopupBanner from "./Pages/HomePage/PopupBanner";
import AlumniGallery from "./Pages/AlumniSection/AlumniGallery";
import TrainingPartners from "./Pages/Research/TrainingPartners";
import TrainingPartnerDocs from "./Pages/Career/TrainingPartnerDocs";


function App() {
  return (
    <div>
      {/* <LoginPage/> */}

      {/* <Routes>
        <Route path="/" element={  <LoginPage/>} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes> */}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route
            path="/sab"
            element={
              <PrivateRoute>
                <SABLayout />
              </PrivateRoute>
            }
          >


            <Route
              path="sliderManagement"
              element={
                <PrivateRoute>
                  <SliderManagement />
                </PrivateRoute>
              }
            />
            <Route path="about-alumni" element={<AboutAlumni />} />
            <Route path="welcome-section" element={<WelcomeSection />} />
            <Route
              path="AboutAlumniupdateGoals"
              element={<AboutAlumniupdateGoals />}
            />
            <Route path="alumni-news" element={<AlumniLatestNews />} />
            <Route
              path="alumni-registration"
              element={<AlumniRegistration />}
            />
             <Route path="popup-banner" element={<PopupBanner />} />
             <Route path="intakes" element={<Intakes />} />
             <Route path="alumini-directory" element={<AlumniDirectory />} />
             <Route path="alumini-gallery" element={<AlumniGallery />} />

            <Route path="sab-src" element={<SABSRC />} />

            
            

            <Route
              path="partners-accreditations-management"
              element={<PartnersAccrMng />}
            />
            <Route path="student-events" element={<StudentEvents />} />
            <Route path="student-events-edits" element={<StudentEventsEdit/>}/>
            <Route path="research-publications" element={<ResearchPublications />} />
            <Route path="student-life" element={<StudentLife />} />
            <Route path="csr-projects" element={<CSRProjects />} />
            <Route path="training-partners" element={<TrainingPartners />} />     
            <Route path="student-sports" element={<Sports/>}/>        
            <Route path="careerGuidance-internships" element={<CareerGuidanceInternships/>}/> 
            <Route path="career" element={<Career/>}/>
            <Route path="training-partner-docs" element={<TrainingPartnerDocs/>}/>

            <Route path="partners-accreditations-management" element={<PartnersAccrMng />} />

            <Route path="gallery-management" element={<GalleryManagement />} />
            <Route path="add-new-publication" element={<AddPublication />} />
            <Route path="clubs-and-societies" element={<AddClubSociety />} />
            <Route path="club-Society-List" element={<ClubSocietyList />} />
          </Route>

          

          {/* <Route path="vision" element={<About_SAB />} /> */}
          <Route path="/PartnersAccrMng" element={<PartnersAccrMng />} />
          <Route path="/GalleryManagement" element={<GalleryManagement />} />

          <Route path="/PartnersAccrMng" element={<PartnersAccrMng />} />
          <Route path="/GalleryManagement" element={<GalleryManagement />} />
          <Route path="/leadershipMessage" element={<LeadershipMessages />} />
          <Route path="/council" element={<Council />} />

          <Route path="/aboutus" element={<PrivateRoute><SABLayout /></PrivateRoute>}>
            <Route path="vision" element={<About_SAB />} />
            <Route path="leadershipMessage" element={<LeadershipMessages />} />
            <Route path="council" element={<Council />} />
            <Route path="boardOfManagement" element={<Management />} />
            <Route path="boardOfStudies" element={<Studies />} />
            <Route path="history" element={<OurHistory />} />
            
          </Route>

          <Route path="/academics&international" element={<PrivateRoute><SABLayout /></PrivateRoute>}>
            <Route path="departmentManagement">
              <Route path="department" element={<DepartmentManagement />} />
              <Route
                path="leadershipMessages"
                element={<LeadershipMessageDep />}
              />
              <Route path="academicStaff" element={<AcademicStaff />} />
              <Route path="allStaff" element={<AllStaff />} />
            </Route>
            <Route path="degreeManagement">
              <Route path="addDegree" element={<AddDegree />} />
              <Route path="allDegree" element={<AllDegree />} />
              
            </Route>
            <Route path="applications" element={<Applications />} />
            <Route path="international">
              <Route path="addProgram" element={<AddProgram />} />
              <Route path="allPrograms" element={<AllPrograms />} />
            </Route>
            <Route path="loanScheme">
              <Route path="addLoan" element={<AddLoan />} />
              <Route path="allLoans" element={<AllLoans />} />
            </Route>
            <Route path="scholarships">
              <Route path="addScholarship" element={<AddScholarship />} />
              <Route path="allScholarships" element={<AllScholarships />} />
            </Route>
          </Route>

          <Route path="it-services" element={<PrivateRoute><SABLayout /></PrivateRoute>}>
            <Route path="service-menu" element={<ITServices />} />
            <Route path="student-portal" element={<StudentPortal />} />
            <Route path="office" element={<Office />} />
            <Route path="online-payment" element={<OnlinePayment />} />
            <Route path="password-managment" element={<PasswordManagment />} />
            <Route path="help-desk" element={<HelpDesk />} />
            <Route path="ims" element={<IMS />} />
            <Route path="student-counsellor" element={<Student_Counsellor />} />
          </Route>

          <Route path="contact-us" element = {<PrivateRoute><SABLayout/></PrivateRoute>}>
          <Route path = "contact-information" element = {<ContactInformation/>}/>    
          <Route path = "inquiry" element = {<Inquiry/>}/>       
          </Route>

          <Route path="gallery&News" element={<PrivateRoute><SABLayout /></PrivateRoute>}>
            <Route path="add-news" element={<AddNews />} />
            <Route path="list-news" element={<GetNews />} />
            <Route path="cqa-description" element={<GetCQADesc />} />
            <Route path="add-cqa" element={<AddCQA />} />
            <Route path="get-cqa" element={<GetCQA />} />
            <Route path="cqa-staff" element={<CQAStaff />} />
            <Route path="news-gallery-management" element={<NewsGalleryManagement />} />
            <Route path="video-gallery" element={<VideoGallery />} />
          </Route>

          
          {/* <Route path="department" element={<DepartmentManagement />} /> */}
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
